import type { ReactNode } from 'react';
import { HelpdeskRuntimeContext, type HelpdeskRuntime } from './runtime';
export function HelpdeskRuntimeProvider({
  runtime,
  children,
}: {
  runtime: HelpdeskRuntime;
  children: ReactNode;
}) {
  return (
    <HelpdeskRuntimeContext.Provider value={runtime}>{children}</HelpdeskRuntimeContext.Provider>
  );
}
